import { messageToAdminConstants } from "./constans"

const initialState =
{
	isMessageSending : false,
	isSending        : false,
	paged            : {},
	isRead           : false,
	isSpam           : false,
	isSend           : false
}

export default function (state = initialState, action){
	switch (action.type){
		case messageToAdminConstants.GetPaged.REQUEST :
		case messageToAdminConstants.Read.REQUEST :
			return {
				...state,
				isSpam           : false,
				isSending        : true,
				isRead           : false,
				isSend           : false,
				isMessageSending : false
			}
		case messageToAdminConstants.GetPaged.SUCCESS :
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case messageToAdminConstants.GetPaged.FAILURE :
		case messageToAdminConstants.Read.FAILURE :
			return {
				...state,
				isSending : false,
				error     : action.payload
			}
		case messageToAdminConstants.Create.REQUEST :
		case messageToAdminConstants.Spam.REQUEST :
			return {
				...state,
				isSend           : false,
				isMessageSending : true
			}
		case messageToAdminConstants.Create.SUCCESS :
			return {
				...state,
				isSend           : true,
				isMessageSending : false
			}
		case messageToAdminConstants.Create.FAILURE :
		case messageToAdminConstants.Spam.FAILURE:
			return {
				...state,
				isMessageSending : false,
				error            : action.payload
			}
		case messageToAdminConstants.Read.SUCCESS :
			return {
				...state,
				isRead: true
			}
		case messageToAdminConstants.Spam.SUCCESS :
			return {
				...state,
				isSpam: true
			}
		case messageToAdminConstants.CLEAR:
			return {
				...state,
				isMessageSending : false,
				isSending        : false,
				paged            : {},
				isRead           : false,
				isSpam           : false,
				isSend           : false
			}
		default :
			return state
	}
}